var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphProductions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 59,
    viewBox: "0 0 52 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_535_5929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3283 30.9835H5.33638C4.78036 30.9835 4.32959 31.4343 4.32959 31.9903V45.3824C4.32959 45.9385 4.78036 46.3892 5.33638 46.3892H10.3283C10.8843 46.3892 11.3351 45.9385 11.3351 45.3824V31.9903C11.3351 31.4343 10.8843 30.9835 10.3283 30.9835Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.651 18.892H14.6591C14.1031 18.892 13.6523 19.3428 13.6523 19.8988V45.3827C13.6523 45.9387 14.1031 46.3894 14.6591 46.3894H19.651C20.207 46.3894 20.6578 45.9387 20.6578 45.3827V19.8988C20.6578 19.3428 20.207 18.892 19.651 18.892Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9752 24.492H23.9833C23.4273 24.492 22.9766 24.9428 22.9766 25.4988V45.3825C22.9766 45.9385 23.4273 46.3893 23.9833 46.3893H28.9752C29.5312 46.3893 29.982 45.9385 29.982 45.3825V25.4988C29.982 24.9428 29.5312 24.492 28.9752 24.492Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3078 14.204H33.3158C32.7598 14.204 32.3091 14.6548 32.3091 15.2108V45.3825C32.3091 45.9385 32.7598 46.3892 33.3158 46.3892H38.3078C38.8638 46.3892 39.3145 45.9385 39.3145 45.3825V15.2108C39.3145 14.6548 38.8638 14.204 38.3078 14.204Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3043 4L32.4038 5.82482L34.0817 7.51325L26.2897 15.2318L16.9981 9.84137L4.46589 21.2619C4.33496 21.3628 4.22636 21.4898 4.14696 21.6347C4.06756 21.7797 4.0191 21.9395 4.00461 22.1042C3.99011 22.2688 4.00992 22.4347 4.06276 22.5913C4.1156 22.7479 4.20034 22.8918 4.31163 23.014C4.42291 23.1362 4.55832 23.234 4.70931 23.3012C4.86031 23.3684 5.02362 23.4036 5.1889 23.4045C5.35417 23.4054 5.51784 23.3721 5.66957 23.3066C5.8213 23.241 5.95778 23.1447 6.07042 23.0238L17.3127 12.7778L26.6673 18.2206L35.7597 9.20167L37.4271 10.8901L39.3043 4Z",
    fill: "#40D3C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_535_5929",
    x: 0,
    y: 0,
    width: 51.3145,
    height: 58.3894,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_535_5929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_535_5929",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphProductions);
export default __webpack_public_path__ + "static/media/graphProductions.74eacd624c8724b88e69779a01d3d63c.svg";
export { ForwardRef as ReactComponent };